<template>
  <div class="fv-layout flex h-full overflow-hidden">
    <div v-if="!loading" class="fv-stage flex-1 min-w-0 overflow-y-auto p-6">
      <AudioTranscriberFull
        ref="audio-transcriber-full"
        :fileId="fileId"
        :lang="file.lang"
        :meta="file"
        :batch_block="batch_block"
        @fileMarked="fileTaggedForModel"
        @save:changedLines="saveChangedLines"
        @fragment-index-changes="fragmentIndexChanged"
        @last-fragment="LastFragment"
        @finish-button-access="finishButtonAccess"
      />
    </div>
    <header class="fv-panel flex-shrink-0 h-full">
      <div class="fv-panel__inner flex flex-col h-full">
        <div class="fv-panel__head">
          <span :class="['fv-statuschip', statusClass(file && file.status)]">
            <span class="fv-statuschip__dot"></span>
            <span class="fv-statuschip__label">{{ stateTitle }}</span>
            <i v-if="loading" class="el-icon-loading"></i>
          </span>
          <div class="fv-panel__id">
            <span class="fv-panel__id-label">ID</span>
            <span class="fv-panel__id-value">{{ fileId }}</span>
          </div>
        </div>
        <div class="fv-panel__body p-3 flex-1 min-h-0 overflow-y-auto">
          <ul class="fv-comments" v-if="file && file.comments">
            <li
              v-for="comment in file.comments"
              :key="comment.datetime"
              class="fv-comment"
            >
              <div class="fv-comment__top">
                <span class="fv-comment__author">
                  {{ comment.author.first_name }} {{ comment.author.last_name }}
                </span>
                <span class="fv-comment__time">
                  {{ dateFormat(comment.datetime, "dd MMM HH:mm") }}
                </span>
              </div>
              <div class="fv-comment__transition">
                <span
                  :class="['fv-status', statusClass(comment.status.before)]"
                >
                  {{ getStatusTitle(comment.status.before) }}
                </span>
                <svg
                  class="fv-comment__arrow"
                  viewBox="0 0 24 24"
                  fill="none"
                  aria-hidden="true"
                >
                  <path
                    d="M4 12H20M20 12L14 6M20 12L14 18"
                    stroke="currentColor"
                    stroke-width="1.6"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <span :class="['fv-status', statusClass(comment.status.after)]">
                  {{ getStatusTitle(comment.status.after) }}
                </span>
              </div>
              <p v-if="comment.comment" class="fv-comment__text">
                {{ comment.comment }}
              </p>
            </li>
          </ul>
        </div>
        <div class="mt-auto">
          <!--          <ul class="text-xs mb-1.5 font-light px-2">-->
          <!--            <li-->
          <!--              v-for="t in tips"-->
          <!--              :key="t"-->
          <!--              @click="comment = t"-->
          <!--              class="border inline-block mr-1 rounded px-1.5 py-0.5 text-gray-500 cursor-pointer hover:bg-gray-50 bg-white"-->
          <!--            >-->
          <!--              {{ t }}-->
          <!--            </li>-->
          <!--          </ul>-->
          <div class="fv-footer">
            <div class="fv-note">
              <span class="fv-note__label">Примечание</span>
              <textarea
                v-model="comment"
                :disabled="batch_block"
                type="textarea"
                placeholder="Оставьте комментарий…"
                name=""
                class="fv-textarea"
                cols="30"
                rows="2"
              ></textarea>
            </div>
            <div v-if="availableButtons.length" class="fv-actions">
              <el-button
                v-for="(button, index) in availableButtons"
                :key="index"
                @click="changeStatus(button.status.to, button.title)"
                :type="button.type"
                plain
                :disabled="changeStatusLoading || batch_block"
              >
                {{ button.title }}
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </header>
    <el-dialog v-model="showRatingDialog" title="Оцените качество">
      <el-rate :size="80" v-model="rating"></el-rate>
    </el-dialog>
  </div>
</template>

<script>
import { changeStatus, getFile, rejectFile } from "@/api/files";
import { getStatus } from "./shared/statuses";
import { format } from "date-fns";
import AudioTranscriberFull from "@/views/files/shared/components/AudioTranscriberFull.vue";

export default {
  components: {
    AudioTranscriberFull,
  },
  props: {
    state: {
      type: [String],
      required: true,
    },
    fileId: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      cue: 0,
      loading: true,
      changeStatusLoading: false,
      showRatingDialog: false,
      rating: null,
      fragmentIndex: 1,
      fullLines: [],
      controlButtons: [
        {
          title: "В работу",
          status: {
            from: 0,
            to: 1,
          },
          scopes: ["verifier", "annotator"],
          type: "primary",
        },
        {
          title: "Завершить",
          sign: "annotator_end",
          status: {
            from: 1,
            to: 2,
          },
          scopes: ["annotator"],
          type: "primary",
        },
        {
          title: "На верификацию",
          status: {
            from: 2,
            to: 3,
          },
          scopes: ["verifier"],
          type: "primary",
        },
        {
          title: "Завершить",
          sign: "verifier_end",
          status: {
            from: 3,
            to: 4,
          },
          scopes: ["verifier", "admin"],
          type: "primary",
        },
        {
          title: "Вернуть на верификацию",
          status: {
            from: 4,
            to: 3,
          },
          scopes: ["verifier", "admin"],
          type: "primary",
        },
        {
          title: "Возврат",
          status: {
            from: 3,
            to: 1,
          },
          scopes: ["verifier"],
          type: "danger",
        },
        {
          title: "Возврат",
          status: {
            from: 1,
            to: 0,
          },
          scopes: ["annotator"],
          type: "danger",
        },
        {
          title: "Возврат в работу",
          status: {
            from: 2,
            to: 1,
          },
          scopes: ["annotator", "verifier"],
          type: "danger",
        },
      ],
      canFinish: false,
      activeTab: "operator",

      file: {},
      comment: null,
      // tips: ["Не прошел верификацию", "Исправлено"],
      rejectFileComment: null,
    };
  },
  computed: {
    RouteState() {
      return parseInt(this.$route.params.state);
    },
    user() {
      return this.$store.state.user.user;
    },
    userScopes() {
      return this.$store.getters["user/getUserScopes"];
    },
    stateTitle() {
      if (!this.file) return null;
      return this.getStatusTitle(this.file.status);
    },
    batch_block() {
      return this.file.batch_block;
    },
    availableButtons() {
      if (!this.file) return [];
      return this.controlButtons.filter((cb) => {
        // Check for the "Размечен" button
        if (
          cb.sign === "annotator_end" &&
          cb.status.from === parseInt(this.file.status)
        ) {
          // Add any additional conditions for the "Размечен" button here
          if (this.userScopes.includes("annotator")) {
            // Check if fragmentIndex is the last index of fullLines
            return (
              this.fragmentIndex === this.fullLines.length && !this.canFinish
            );
          }
        }
        if (
          cb.sign === "verifier_end" &&
          cb.status.from === parseInt(this.file.status)
        ) {
          if (
            this.userScopes.includes("verifier") ||
            this.userScopes.includes("admin")
          ) {
            // Check if fragmentIndex is the last index of fullLines
            return (
              this.fragmentIndex === this.fullLines.length && !this.canFinish
            );
          }
        }

        // For all other buttons, use the existing logic
        if (cb.status.from === parseInt(this.file.status)) {
          const filteredArray = cb.scopes.filter((value) =>
            this.userScopes.includes(value)
          );
          if (filteredArray.length > 0) {
            return true;
          }
        }
        return false;
      });
    },
  },
  async mounted() {
    this.file = await getFile(this.fileId);
    this.loading = false;

    console.log("tempVariable", this.$options.tempVariable);
  },
  methods: {
    finishButtonAccess(access) {
      this.canFinish = access;
    },
    fileTaggedForModel(taggedFileForModel) {
      console.log(this.file);
      this.file.is_model = taggedFileForModel;
    },
    async changeStatus(status, buttonTitle) {
      if (buttonTitle === "Возврат") {
        const confirmed = await this.$confirm(
          `Вы уверены, что хотите вернуть файл? Он вернётся в список Новых файлов.`,
          "Подтверждение",
          {
            confirmButtonText: "Да",
            cancelButtonText: "Отмена",
            type: "warning",
          }
        ).catch(() => false);

        if (!confirmed) return;
      }

      if (
        this.$refs["audio-transcriber-full"] &&
        (this.RouteState === 1 || this.RouteState === 3)
      ) {
        this.$refs["audio-transcriber-full"].triggerSave();
      }

      this.changeStatusLoading = true;

      setTimeout(async () => {
        try {
          const res = await changeStatus(this.fileId, status, this.comment);
          this.changeStatusLoading = false;

          if (res._success) {
            this.$router.push({
              name: "file-view",
              params: { state: status, fileId: this.fileId },
            });
            this.file = await getFile(this.fileId);
          } else {
            this.$message.error(res.message || "Ошибка");
          }
        } catch (error) {
          this.changeStatusLoading = false;
          let errorMessage = "Ошибка при смене статуса";

          if (error.response?.data?.message) {
            errorMessage = error.response.data.message;
          } else if (error.message) {
            errorMessage = error.message;
          }

          this.$message.error(errorMessage);
        }
      }, 500);
    },
    async rejectFile() {
      try {
        const { value } = await this.$msgbox.prompt(
          "Введите комментарий.",
          "Отказ файла",
          {
            confirmButtonText: "Отправить",
            cancelButtonText: "Отменить",
            inputPattern: /^.*\S.*$/, // Ensures the comment is not empty or whitespace
            inputErrorMessage: "Комментарий не может быть пустым.",
          }
        );

        const trimmedComment = value.trim();

        const res = await rejectFile(this.fileId, 6, trimmedComment, 1);
        if (res._success) {
          this.$router.push({
            name: "files-list",
            params: { state: 0 },
          });
        }
      } catch (err) {
        if (err === "cancel") {
          this.$message.info("Отказ файла отменено.");
        } else {
          console.error(err);
        }
      }
    },
    getStatusTitle(status) {
      return getStatus(status) && getStatus(status).title;
    },
    statusClass(status) {
      return (
        {
          1: "fv-status--warning",
          2: "fv-status--info",
          3: "fv-status--success",
          4: "fv-status--indigo",
        }[status] || "fv-status--muted"
      );
    },
    dateFormat(date, frmt) {
      return format(new Date(date), frmt);
    },
    saveChangedLines({ payload }) {
      this.lines = payload;
    },
    fragmentIndexChanged(fragment_index) {
      this.fragmentIndex = fragment_index;
    },
    LastFragment(lines) {
      this.fullLines = lines;
    },
  },
};
</script>

<style lang="scss" scoped>
.el-rate:deep(.el-rate__item) {
  .el-rate-icon {
    font-size: 50px !important;
  }
}

/* Right panel — a floating island (rounded border, gap from edges) */
.fv-panel {
  width: 360px;
  background: transparent; // sits directly on the app-main island
  padding: 12px 12px 12px 0;
  overflow: hidden;

  // Island reads as raised: a surface distinct from the app-main behind it.
  // Light → faint gray; dark → a step lighter than the page.
  &__inner {
    background: var(--muted);
    border: 1px solid var(--border);
    border-radius: 16px;
    box-shadow: var(--shadow-sm);
    overflow: hidden;
  }

  &__head {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    padding: 16px;
    border-bottom: 1px solid var(--border);
  }
  &__id {
    display: inline-flex;
    align-items: center;
    gap: 7px;
  }
  &__id-label {
    font-size: 9.5px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: var(--muted-foreground);
    background: var(--muted);
    border: 1px solid var(--border);
    border-radius: 5px;
    padding: 1px 6px;
  }
  &__id-value {
    font-size: 12px;
    color: var(--muted-foreground);
    font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
    word-break: break-all;
  }
}

/* Status chip in the panel head — dot + label, color by status */
.fv-statuschip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 30px;
  padding: 0 13px 0 11px;
  border-radius: 999px;
  font-size: 14px;
  font-weight: 700;
  border: 1px solid transparent;

  &__dot {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: currentColor;
    flex-shrink: 0;
  }

  &.fv-status--muted {
    background: var(--muted);
    color: var(--muted-foreground);
    border-color: var(--border);
  }
  &.fv-status--warning {
    background: rgba(245, 158, 11, 0.14);
    color: #f59e0b;
  }
  &.fv-status--info {
    background: rgba(59, 130, 246, 0.14);
    color: #3b82f6;
  }
  &.fv-status--success {
    background: rgba(34, 197, 94, 0.14);
    color: #22c55e;
  }
  &.fv-status--indigo {
    background: rgba(99, 102, 241, 0.16);
    color: #6366f1;
  }
}
:global(html.dark) .fv-statuschip.fv-status--info {
  color: #7eb0ff;
}
:global(html.dark) .fv-statuschip.fv-status--indigo {
  color: #a5b4fc;
}

.fv-comments {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

// Comment cards lift above the muted island base
.fv-comment {
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 11px 13px;

  &__top {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 10px;
  }
  &__author {
    font-size: 13px;
    font-weight: 600;
    color: var(--foreground);
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  &__time {
    font-size: 11px;
    color: var(--muted-foreground);
    flex-shrink: 0;
    white-space: nowrap;
  }

  &__transition {
    display: flex;
    align-items: center;
    gap: 7px;
    margin-top: 7px;
  }
  &__arrow {
    width: 16px;
    height: 16px;
    color: var(--muted-foreground);
    flex-shrink: 0;
  }

  &__text {
    margin: 9px 0 0;
    padding-top: 9px;
    border-top: 1px solid var(--border);
    font-size: 12.5px;
    line-height: 1.5;
    color: var(--muted-foreground);
  }
}

/* Status chips inside a transition */
.fv-status {
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding: 0 9px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;

  &--muted {
    background: var(--muted);
    color: var(--muted-foreground);
    border: 1px solid var(--border);
  }
  &--warning {
    background: rgba(245, 158, 11, 0.14);
    color: #f59e0b;
  }
  &--info {
    background: rgba(59, 130, 246, 0.14);
    color: #3b82f6;
  }
  &--success {
    background: rgba(34, 197, 94, 0.14);
    color: #22c55e;
  }
  &--indigo {
    background: rgba(99, 102, 241, 0.16);
    color: #6366f1;
  }
}
:global(html.dark) .fv-status--info {
  color: #7eb0ff;
}
:global(html.dark) .fv-status--indigo {
  color: #a5b4fc;
}

/* Footer — bottom zone of the island: note field + actions */
.fv-footer {
  background: transparent;
  border-top: 1px solid var(--border);
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.fv-note {
  background: var(--background);
  border: 1px solid var(--border);
  border-radius: 10px;
  padding: 8px 12px;
  transition: border-color 0.18s ease, box-shadow 0.18s ease;

  &:focus-within {
    border-color: var(--border-strong);
    box-shadow: 0 0 0 3px var(--ring);
  }

  &__label {
    display: block;
    font-size: 10.5px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: var(--muted-foreground);
    margin-bottom: 4px;
  }
}

.fv-textarea {
  width: 100%;
  background: transparent;
  color: var(--foreground);
  border: 0;
  outline: none;
  resize: none;
  font-size: 13px;
  font-weight: 400;
  line-height: 1.45;

  &::placeholder {
    color: var(--muted-foreground);
  }
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
}

.fv-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 8px;

  // shadcn-style buttons (match FilesList)
  ::v-deep(.el-button) {
    height: 36px;
    margin: 0;
    border-radius: 9px;
    border: 1px solid var(--border);
    background: var(--card);
    color: var(--foreground);
    font-weight: 500;
    transition: background-color 0.18s ease, border-color 0.18s ease;
    &:hover {
      background: var(--accent);
      border-color: var(--border-strong);
      color: var(--foreground);
    }
  }
  ::v-deep(.el-button--primary) {
    background: var(--primary);
    color: var(--primary-foreground);
    border-color: var(--primary);
    &:hover {
      background: var(--primary);
      color: var(--primary-foreground);
      border-color: var(--primary);
      opacity: 0.9;
    }
  }
  ::v-deep(.el-button--danger) {
    color: #ef4444;
    &:hover {
      background: rgba(239, 68, 68, 0.1);
      border-color: rgba(239, 68, 68, 0.4);
      color: #ef4444;
    }
  }
}
</style>
